<template>
  <section class="custom-dashboard-notifications">
    <div
      class="flex items-center justify-between py-2 !px-3"
      style="justify-content: space-between"
    >
      <div class="flex items-center justify-between !gap-2 w-full">
        <span class="text-black-950 text-xs lg:!text-sm 3xl:text-base font-normal">
          {{ component.component_name }}
        </span>
        <div v-if="!loading" @click="getNecessaryInfo(true)" style="cursor: pointer">
          <i class="el-icon-refresh"></i>
        </div>
      </div>
      <div class="flex items-center !gap-3">
        <el-dropdown trigger="click" v-if="!hide_options">
          <el-link :underline="false">
            <img src="@/assets/img/icons/new/more-icon.svg" alt="" class="!size-6" />
          </el-link>
          <el-dropdown-menu slot="dropdown">
            <a @click="editComponent">
              <el-dropdown-item>Edit</el-dropdown-item>
            </a>
            <a @click="deleteComponent">
              <el-dropdown-item>Delete</el-dropdown-item>
            </a>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="d-flex">
        <el-button
          v-if="component.unique_key"
          icon="el-icon-delete"
          type="text"
          @click="$emit('deleteNotifications', component)"
        ></el-button>
      </div>
    </div>
    <div class="notifications-container" v-loading="loading" v-if="notificationsData.length">
      <div class="scroll-container">
        <div class="mb-1 mr-1 ml-1">
          <div
            v-for="(notification, index) in notificationsData"
            :key="index"
            @click="redirect(notification)"
          >
            <el-card
              id="notificationCard"
              class="custom-card hover:scale-101 transition duration-300 ease-in-out hover:!shadow-xl"
              :style="`margin-bottom: 5px; border-radius: 3px; background-color:${hexToRgb(
                notification.background_color,
                0.1
              )}; border: 0.1px solid ${notification.background_color}`"
            >
              <div class="d-flex">
                <div
                  :style="{
                    '--icon-color': notification.background_color,
                    display: 'flex',
                    'align-items': 'center',
                    padding: '8px',
                    'background-color': hexToRgb(notification.background_color, 0.15),
                    'border-radius': '5px',
                  }"
                  class="notification-icon"
                >
                  <icons :iconName="notification.icon"></icons>
                </div>
                <div class="ml-1">
                  <h4 class="text-xs 2xl:text-sm font-medium !text-black-800">
                    {{ notification.heading | truncate(47, '...') }}
                  </h4>
                  <p
                    class="text-[10px] xl:text-xs text-black-700"
                    v-html="notification.custom_message"
                  ></p>
                </div>
                <div class="flex-grow-1 text-right">
                  <span class="date-time text-black-600 fw-normal pl-0">
                    {{ getNotificationTime(notification) | getFormattedDateTypeThree }}
                  </span>
                </div>
              </div>
            </el-card>
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              text-align: center;
              font-size: 16px;
              font-weight: bold;
            "
            v-if="hasMore"
            @click="loadMore"
          >
            {{ loadMoreText }}
          </div>
        </div>
      </div>
    </div>
    <div v-else v-loading="loading">
      <el-empty description="No Notifications"></el-empty>
    </div>
  </section>
</template>

<script>
  import { postAPICall } from '../../helpers/httpHelper';
  import FieldStylesHelper from '../../mixins/FieldStylesHelper';
  import CustomDashboardConfig from '@/mixins/CustomDashboardHelper.js';
  import NavigationHelper from '@/mixins/navigationHelper';
  import { mapGetters } from 'vuex';
  export default {
    props: ['component', 'index', 'hide_options', 'isFromApplicationuser'],
    mixins: [FieldStylesHelper, NavigationHelper, CustomDashboardConfig],
    data() {
      return {
        page: 1,
        limit: 100,
        notificationsData: [],
        hasMore: false,
        entity_id: null,
        loading: false,
        loadMoreText: 'Load more...',
      };
    },
    async mounted() {
      await this.getNecessaryInfo();
      setTimeout(() => {
        this.getNecessaryInfo(true);
      }, 1000);
    },
    computed: {
      ...mapGetters('auth', ['getActiveContactType', 'getGlobalFiltervalue']),
      ...mapGetters('entities', ['getEntityPrimaryData']),
      ...mapGetters('entityCustomization', ['getAllCustomizations']),
      ...mapGetters('menuManagementV2', ['getEntityMenu']),
    },
    methods: {
      getNotificationTime(notification) {
        const createdAt = new Date(notification.created_at);
        const updatedAt = new Date(notification.updated_at);
        const isAddedNotification = notification?.events?.includes('ADDED');
        const isUpdatedNotification = notification?.events?.includes('UPDATED');
        if (isUpdatedNotification || updatedAt > createdAt) {
          return updatedAt;
        }
        if (isAddedNotification || updatedAt == createdAt) {
          return createdAt;
        }
        return notification.updated_at;
      },
      async loadMore() {
        this.loadMoreText = 'Loading...';
        this.page++;
        await this.getNecessaryInfo();
        this.loadMoreText = 'Load more items...';
      },
      async getNecessaryInfo(isRefresh = false) {
        if (this.$route.name != 'entity-custom-dashboard-config') {
          this.setApplicationUserFilters();
        }
        if (isRefresh) {
          this.page = 1;
          this.notificationsData = [];
        }
        this.loading = true;
        this.entity_id = this.component.notifications[0].entity_id;
        if (this.getGlobalFiltervalue) {
          this.component.globalFilter = this.addGlobalFilters(
            [],
            this.entity_id,
            this.checkGlobalFilter
          );
        }
        // Ensure pagination parameters are numbers
        const pageNum = parseInt(this.page);
        const limitNum = parseInt(this.limit);

        // Validate pagination parameters
        if (isNaN(pageNum) || isNaN(limitNum) || pageNum < 1 || limitNum < 1) {
          this.loading = false;
          return;
        }

        // Validate entity IDs before making the API call
        const invalidEntityIds = this.component.notifications.filter(
          (n) => !n.entity_id || n.entity_id.length !== 24
        );
        if (invalidEntityIds.length > 0) {
          this.loading = false;
          return;
        }

        // Create payload with pagination parameters
        const payload = {
          ...this.component,
          page: pageNum,
          limit: limitNum,
        };

        let responseData;
        try {
          responseData = await postAPICall('POST', `/entities/notifications`, payload);
        } catch (error) {
          this.loading = false;
          return;
        }

        this.resetNotificationFilters();
        const filteredData = responseData.data.filter((notification) => {
          if (
            Array.isArray(notification.events) &&
            notification.events.length === 1 &&
            notification.events[0] === 'UPDATED'
          ) {
            const createdAt = new Date(notification.created_at).getTime();
            const updatedAt = new Date(notification.updated_at).getTime();
            const diffSeconds = (updatedAt - createdAt) / 1000;
            return diffSeconds > 5;
          }
          return true;
        });
        this.notificationsData = [...this.notificationsData, ...filteredData];
        this.hasMore = responseData.hasMore;
        this.loading = false;
      },
      editComponent() {
        this.$emit('editComponent', this.index);
      },
      deleteComponent() {
        this.$confirm('Are you sure to delete the Notification component?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          this.$emit('deleteComponent', this.index);
        });
      },
      async redirect(notification) {
        if (notification.redirect === false) return;
        let matchedMenuId = null;
        const hasPageDashboard = this.getEntityMenu?.menu_list?.some(
          (menu) => menu.feature === 'page_dashboard'
        );
        if (
          this.isFromApplicationuser &&
          this.getEntityMenu?.menu_list?.length &&
          this.$route?.query?.menu_id &&
          hasPageDashboard
        ) {
          this.getEntityMenu.menu_list.forEach((menu) => {
            if (matchedMenuId) return;
            if (menu.relational_entity === notification.entity_id) {
              matchedMenuId = menu._id;
              return;
            }
            (menu.children || []).forEach((child) => {
              if (matchedMenuId) return;
              if (child.relational_entity === notification.entity_id) {
                matchedMenuId = child._id;
              }
            });
          });
        }
        if (
          !['custom-dashboard-config', 'entity-custom-dashboard-config'].includes(this.$route.name)
        ) {
          let routerData;
          if (
            ['application-user-dashboard', 'application-user-page-dashboard'].includes(
              this.$route.name
            )
          ) {
            if (notification?.formbuilder_id) {
              routerData = this.$router.resolve(
                `/ap/fb/${notification.formbuilder_code}/${notification.form_builder_data_id}`
              );
            } else {
              let query = this.getNavigationQuery(this.$route.query);
              if (notification.filter) {
                query.filter = notification.filter;
              }
              if (notification.customization) {
                query.customization = notification.customization;
              }
              if (matchedMenuId) query.menu_id = matchedMenuId;
              routerData = this.$router.resolve({
                path: `/ap/entity-view/${notification.entity_id}?key=${Math.floor(
                  Math.random() * 100000
                )}&dataId=${notification._id}&fromCustom=true`,
                query: {
                  ...query,
                  type: 'AUfYWb7SC6U=',
                },
              });
            }
          } else {
            if (notification?.formbuilder_id) {
              routerData = this.$router.resolve(
                `/fb/${notification.formbuilder_code}/${notification.form_builder_data_id}`
              );
            } else {
              let query = this.getNavigationQuery({
                dataId: notification._id,
                ...this.$route.query,
              });
              if (notification.filter) {
                query.filter = notification.filter;
              }
              if (notification.customization) {
                query.customization = notification.customization;
              }
              if (matchedMenuId) query.menu_id = matchedMenuId;
              routerData = this.$router.resolve({
                path: `/entity/view/${notification.entity_id}`,
                query: {
                  ...query,
                },
              });
            }
          }
          window.open(routerData.href, '_blank');
        }
      },
      setApplicationUserFilters() {
        this.component.notifications.map((notification) => {
          if (notification?.relationship_id && !notification?.relationship_id.includes('@')) {
            let value = this.getActiveContactType?.account_data_id;
            let relation_entity_id = this.getActiveContactType?.contact_type?._id;
            if (
              this.component.selectedRelationalFilter &&
              this.component.selectedRelationalFilter != 'login_user' &&
              this.getEntityPrimaryData?.templates_data
            ) {
              let [entityId, templateId, fieldKey] =
                this.component.selectedRelationalFilter?.split('#');
              let tempData = (this.getEntityPrimaryData.templates_data || []).find(
                (tempData) => tempData.template_id == templateId
              );
              relation_entity_id = entityId;
              if (tempData?.template_data_id?.template_data?.[fieldKey]) {
                value = tempData.template_data_id.template_data[fieldKey];
                relation_entity_id = entityId;
              }
            }
            notification['customFilters'] = [
              {
                data_type: 'RELATION',
                field: notification.relationship_id.includes('#')
                  ? 'nested#related_to/'
                  : 'self#related_to',
                operator: 'in',
                query_type: 'AND',
                nested_related_id: notification.relationship_id.includes('#')
                  ? notification.relationship_id.split('#')[0]
                  : '',
                relation_entity_id: relation_entity_id,
                value: [value],
              },
            ];
          }
        });
      },
      resetNotificationFilters() {
        this.component.notifications = this.component.notifications.map((n) => {
          delete n['customFilters'];
          return n;
        });
      },
    },
    watch: {
      getGlobalFiltervalue: {
        async handler() {
          if (this.checkGlobalFilter?.apply_on) {
            this.loading = true;
            if (this.getGlobalFiltervalue) {
              this.component.globalFilter = this.addGlobalFilters(
                [],
                this.entity_id,
                this.checkGlobalFilter
              );
            } else {
              delete this.component.globalFilter;
            }
            const payload = {
              ...this.component,
              page: parseInt(this.page),
              limit: parseInt(this.limit),
            };

            let responseData = await postAPICall('POST', `/entities/notifications`, payload);
            this.resetNotificationFilters();
            this.notificationsData = [...responseData.data];
            this.hasMore = responseData.hasMore;
            this.loading = false;
          }
        },
      },
    },
  };
</script>
<style lang="scss">
  .custom-dashboard-notifications {
    min-height: 370px !important;
    border-radius: 5px;
    background-color: var(--card-color);
  }
  .date-time {
    font-style: normal;
    min-width: 100px;
    text-align: right;
    font-size: 12px;

    @media (max-width: 499.98px) {
      min-width: 70px !important;
    }
  }

  .notification-icon {
    .icon {
      width: 35px;
      height: auto;

      .primary {
        fill: var(--icon-color) !important;
      }

      .stroke {
        stroke: var(--icon-color) !important;
        fill: #fff !important;
      }
    }
  }
</style>
<style scoped lang="scss">
  .scroll-container {
    max-height: 330px;
    overflow-y: auto;
    scrollbar-width: thin;
  }

  .scroll-container {
    scrollbar-width: none;
  }

  .scroll-container:hover {
    scrollbar-width: thin;
  }
</style>
